import { Stack, Typography } from "@mui/material"

interface TextBoxComponentItem {
  type: string,
  content: string,
}

interface TextBoxComponentProps {
  content: TextBoxComponentItem[]
}

function TextBoxComponent( props: TextBoxComponentProps ) {
  return (
  <Stack
    flexGrow={1}
    width={'100%'}
    spacing={2}
    alignItems={'center'}
  >
    {
      props.content.map((item, index) => {
        if (item.type === 'header') {
          return <Typography variant="h2" width={'100%'} key={index}>{item.content}</Typography>
        } else {
          return <Typography variant="body1" width={'100%'} key={index}>{item.content}</Typography>
        }
      })
    }

  </Stack>)
}

export default TextBoxComponent;
